// @ts-nocheck
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { DealerStateContext } from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import React, { FC, useContext } from "react";

const PageTitle = getWidgetComponent("Basic/PageTitle");

const DealerDetailsTitle: FC<WidgetProps> = () => {
    const { value: dealer } = useContext(DealerStateContext);

    if (!dealer) {
        return null;
    }

    return <PageTitle overrideTitle={`${translate("Location")} - ${dealer.name}`} />;
};

const widgetModule: WidgetModule = {
    component: DealerDetailsTitle,
    definition: {
        group: "Dealer Details",
        displayName: "Dealer Details Title",
        allowedContexts: ["DealerDetailsPage"],
    },
};

export default widgetModule;
